import { render, staticRenderFns } from "./CabinetDetails.vue?vue&type=template&id=60bed0d8&scoped=true"
import script from "./CabinetDetails.vue?vue&type=script&lang=js"
export * from "./CabinetDetails.vue?vue&type=script&lang=js"
import style0 from "./CabinetDetails.vue?vue&type=style&index=0&id=60bed0d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bed0d8",
  null
  
)

export default component.exports